import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../core/services/api.service';
import { PageTitleService } from '../../../core/services/page-title.service';

@Component({
  selector: 'app-book-locator',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './book-locator.component.html',
  styleUrl: './book-locator.component.scss',
})
export class BookLocatorComponent implements OnInit {

  searchInput = '';
  isSearching = false;
  hasSearched = false;
  searchError = '';
  results: any[] = [];

  selectedBook: any = null;
  showCopiesModal = false;
  isCopiesLoading = false;
  copiesError = '';

  constructor(private api: ApiService, private pageTitle: PageTitleService) {}

  ngOnInit(): void {
    this.pageTitle.set('Book Locator', 'Find where every copy of a book currently is');
  }

  search(): void {
    const term = this.searchInput.trim();
    if (!term) return;

    this.isSearching = true;
    this.hasSearched = false;
    this.searchError = '';
    this.results = [];

    this.api.locateBook(term).subscribe({
      next: (data) => {
        this.results = data || [];
        this.hasSearched = true;
        this.isSearching = false;
      },
      error: (err) => {
        this.searchError = err?.message || 'Search failed. Please try again.';
        this.hasSearched = true;
        this.isSearching = false;
      },
    });
  }

  viewCopies(book: any): void {
    this.selectedBook = { ...book, copies: null };
    this.isCopiesLoading = true;
    this.copiesError = '';
    this.showCopiesModal = true;

    this.api.getBookCopies(book._id).subscribe({
      next: (copies) => {
        this.selectedBook = { ...this.selectedBook, copies: copies || [] };
        this.isCopiesLoading = false;
      },
      error: (err) => {
        this.copiesError = err?.message || 'Failed to load copy details.';
        this.isCopiesLoading = false;
      },
    });
  }

  closeModal(): void {
    this.showCopiesModal = false;
    this.selectedBook = null;
    this.copiesError = '';
  }

  get copiesAvailable(): number {
    return (this.selectedBook?.copies || []).filter((c: any) => c.status === 'C').length;
  }

  get copiesIssued(): number {
    return (this.selectedBook?.copies || []).filter((c: any) => c.status === 'M').length;
  }

  get copiesTotal(): number {
    return (this.selectedBook?.copies || []).length;
  }

  statusClass(status: string): string {
    if (status === 'C') return 'bl-status-center';
    if (status === 'M') return 'bl-status-issued';
    if (status === 'S') return 'bl-status-scrapped';
    return '';
  }

  statusLabel(status: string): string {
    if (status === 'C') return 'At Center';
    if (status === 'M') return 'Issued';
    if (status === 'S') return 'Scrapped';
    return status;
  }
}
